'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createWixData;
var WixDataApi = require('wix-data-core/lib/data-api');

var _require = require('./create-wix-data-proxy'),
    createWixDataProxy = _require.createWixDataProxy;

function createWixData(elementorySupportInstance) {
  return new WixDataApi(createWixDataProxy(elementorySupportInstance));
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-code-platform/lib/create-wix-data.js
// module id = 242
// module chunks = 0